import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Session and conversation state
  sessionId: '',
  conversation: [],
  isLandPageVisible: true,
  isGroupChatActive: false,

  // Workspace selection state
  selectedFabricId: null,
  selectedWorkspaceId: null,
  selectedFabricName: null,
  selectedWorkspaceData: null,

  // Sidebar state
  currentSidebarView: 'workspaces', // 'workspaces' or 'history'
};

const airspaceSlice = createSlice({
  name: 'airspace',
  initialState,
  reducers: {

    // ── Session ────────────────────────────────────────────
    setSessionId(state, action) {
      state.sessionId = action.payload;
    },

    // ── Conversation ───────────────────────────────────────
    setConversation(state, action) {
      state.conversation = action.payload;
    },

    setIsLandPageVisible(state, action) {
      state.isLandPageVisible = action.payload;
    },

    setIsGroupChatActive(state, action) {
      state.isGroupChatActive = action.payload;
    },

    // ── Workspace Selection ────────────────────────────────
    setSelectedFabricId(state, action) {
      state.selectedFabricId = action.payload;
    },

    setSelectedWorkspaceId(state, action) {
      state.selectedWorkspaceId = action.payload;
    },

    setSelectedFabricName(state, action) {
      state.selectedFabricName = action.payload;
    },

    setSelectedWorkspaceData(state, action) {
      state.selectedWorkspaceData = action.payload;
    },

    // ── Sidebar ────────────────────────────────────────────
    setCurrentSidebarView(state, action) {
      state.currentSidebarView = action.payload;
    },

    // ── Bulk workspace selection update ────────────────────
    setWorkspaceSelection(state, action) {
      const { fabricId, workspaceId, fabricName, workspaceData } = action.payload;
      state.selectedFabricId = fabricId;
      state.selectedWorkspaceId = workspaceId;
      state.selectedFabricName = fabricName;
      state.selectedWorkspaceData = workspaceData;
    },

    // ── New Conversation (full reset) ──────────────────────
    resetAirspaceState() {
      return initialState;
    },
  },
});

export const {
  setSessionId,
  setConversation,
  setIsLandPageVisible,
  setIsGroupChatActive,
  setSelectedFabricId,
  setSelectedWorkspaceId,
  setSelectedFabricName,
  setSelectedWorkspaceData,
  setCurrentSidebarView,
  setWorkspaceSelection,
  resetAirspaceState,
} = airspaceSlice.actions;

// ── Thunk: safe functional update for conversation ─────────
// Same pattern as copilotSlice — reads LATEST state before applying.
// Critical for streaming where rapid updates would see stale state.
export const updateConversation = (updater) => (dispatch, getState) => {
  const current = getState().airspace.conversation;
  const newValue = typeof updater === 'function' ? updater(current) : updater;
  dispatch(setConversation(newValue));
};

export default airspaceSlice.reducer;